var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "home" }, [
    _c("header", { staticClass: "hero" }, [
      _c("div", { staticClass: "hero-inner" }, [
        _c("div", { staticClass: "badge" }, [
          _c("span", { staticClass: "badge-ic" }, [
            _c(
              "svg",
              {
                attrs: {
                  viewBox: "0 0 64 34",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }
              },
              [
                _c("rect", {
                  attrs: {
                    x: "2",
                    y: "2",
                    width: "56",
                    height: "24",
                    rx: "7",
                    fill: "#fff"
                  }
                }),
                _vm._v(" "),
                _c("rect", {
                  attrs: {
                    x: "2",
                    y: "20",
                    width: "56",
                    height: "3",
                    fill: "#07c160"
                  }
                }),
                _vm._v(" "),
                _c("rect", {
                  attrs: {
                    x: "7",
                    y: "7",
                    width: "9",
                    height: "9",
                    rx: "2",
                    fill: "#0b3d33"
                  }
                }),
                _vm._v(" "),
                _c("rect", {
                  attrs: {
                    x: "20",
                    y: "7",
                    width: "9",
                    height: "9",
                    rx: "2",
                    fill: "#0b3d33"
                  }
                }),
                _vm._v(" "),
                _c("rect", {
                  attrs: {
                    x: "33",
                    y: "7",
                    width: "9",
                    height: "9",
                    rx: "2",
                    fill: "#0b3d33"
                  }
                }),
                _vm._v(" "),
                _c("rect", {
                  attrs: {
                    x: "46",
                    y: "7",
                    width: "7",
                    height: "16",
                    rx: "2",
                    fill: "#0b3d33"
                  }
                }),
                _vm._v(" "),
                _c("circle", {
                  attrs: { cx: "16", cy: "27", r: "5", fill: "#1f2937" }
                }),
                _c("circle", {
                  attrs: { cx: "16", cy: "27", r: "2", fill: "#cfd8dc" }
                }),
                _vm._v(" "),
                _c("circle", {
                  attrs: { cx: "46", cy: "27", r: "5", fill: "#1f2937" }
                }),
                _c("circle", {
                  attrs: { cx: "46", cy: "27", r: "2", fill: "#cfd8dc" }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c("span", [_vm._v("果城行丨公共出行服务查询")])
        ]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _vm._m(2)
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "road" }, [
        _c(
          "svg",
          {
            staticClass: "bus",
            attrs: {
              viewBox: "0 0 64 34",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }
          },
          [
            _c("rect", {
              attrs: {
                x: "2",
                y: "2",
                width: "56",
                height: "24",
                rx: "7",
                fill: "#ffffff"
              }
            }),
            _vm._v(" "),
            _c("rect", {
              attrs: {
                x: "2",
                y: "20",
                width: "56",
                height: "3",
                fill: "#07c160"
              }
            }),
            _vm._v(" "),
            _c("rect", {
              attrs: {
                x: "7",
                y: "7",
                width: "9",
                height: "9",
                rx: "2",
                fill: "#0b3d33"
              }
            }),
            _vm._v(" "),
            _c("rect", {
              attrs: {
                x: "20",
                y: "7",
                width: "9",
                height: "9",
                rx: "2",
                fill: "#0b3d33"
              }
            }),
            _vm._v(" "),
            _c("rect", {
              attrs: {
                x: "33",
                y: "7",
                width: "9",
                height: "9",
                rx: "2",
                fill: "#0b3d33"
              }
            }),
            _vm._v(" "),
            _c("rect", {
              attrs: {
                x: "46",
                y: "7",
                width: "7",
                height: "16",
                rx: "2",
                fill: "#0b3d33"
              }
            }),
            _vm._v(" "),
            _c("circle", {
              attrs: { cx: "16", cy: "27", r: "5", fill: "#1f2937" }
            }),
            _c("circle", {
              attrs: { cx: "16", cy: "27", r: "2", fill: "#cfd8dc" }
            }),
            _vm._v(" "),
            _c("circle", {
              attrs: { cx: "46", cy: "27", r: "5", fill: "#1f2937" }
            }),
            _c("circle", {
              attrs: { cx: "46", cy: "27", r: "2", fill: "#cfd8dc" }
            })
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c("main", { staticClass: "body" }, [
      _c("section", { staticClass: "sec" }, [
        _c("h2", [_vm._v("核心功能")]),
        _vm._v(" "),
        _c("p", { staticClass: "sec-sub" }, [
          _vm._v("为南充市民出行打造的实时公交服务")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "feat-list" }, [
          _c("div", { staticClass: "feat" }, [
            _c("span", { staticClass: "feat-ic" }, [
              _c(
                "svg",
                {
                  attrs: {
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }
                },
                [
                  _c("circle", {
                    attrs: {
                      cx: "12",
                      cy: "12",
                      r: "9",
                      stroke: "#06ad56",
                      "stroke-width": "2"
                    }
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      d: "M12 7.5v4.5l3.2 2",
                      stroke: "#06ad56",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }
                  })
                ]
              )
            ]),
            _vm._v(" "),
            _vm._m(3)
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "feat" }, [
            _c("span", { staticClass: "feat-ic" }, [
              _c(
                "svg",
                {
                  attrs: {
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M6 18c6.5 0 5.5-12 12-12",
                      stroke: "#06ad56",
                      "stroke-width": "2",
                      "stroke-linecap": "round"
                    }
                  }),
                  _vm._v(" "),
                  _c("circle", {
                    attrs: { cx: "6", cy: "18", r: "2.2", fill: "#06ad56" }
                  }),
                  _vm._v(" "),
                  _c("circle", {
                    attrs: { cx: "18", cy: "6", r: "2.2", fill: "#06ad56" }
                  })
                ]
              )
            ]),
            _vm._v(" "),
            _vm._m(4)
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "feat" }, [
            _c("span", { staticClass: "feat-ic" }, [
              _c(
                "svg",
                {
                  attrs: {
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      d:
                        "M12 3.6l2.5 5.1 5.6.8-4 4 .9 5.6-5-2.6-5 2.6.9-5.6-4-4 5.6-.8z",
                      stroke: "#06ad56",
                      "stroke-width": "2",
                      "stroke-linejoin": "round"
                    }
                  })
                ]
              )
            ]),
            _vm._v(" "),
            _vm._m(5)
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "feat" }, [
            _c("span", { staticClass: "feat-ic" }, [
              _c(
                "svg",
                {
                  attrs: {
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      d:
                        "M12 21s-6.2-5-6.2-10.2a6.2 6.2 0 1 1 12.4 0C18.2 16 12 21 12 21z",
                      stroke: "#06ad56",
                      "stroke-width": "2",
                      "stroke-linejoin": "round"
                    }
                  }),
                  _vm._v(" "),
                  _c("circle", {
                    attrs: {
                      cx: "12",
                      cy: "10.6",
                      r: "2.2",
                      stroke: "#06ad56",
                      "stroke-width": "2"
                    }
                  })
                ]
              )
            ]),
            _vm._v(" "),
            _vm._m(6)
          ])
        ])
      ]),
      _vm._v(" "),
      _vm._m(7),
      _vm._v(" "),
      _vm._m(8)
    ]),
    _vm._v(" "),
    _vm._m(9)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h1", [
      _vm._v("南充公交"),
      _c("em", [_vm._v("实时")]),
      _vm._v("掌握")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "hero-sub" }, [
      _vm._v("\n        到站查询 · 换乘规划 · 站点周边"),
      _c("br"),
      _vm._v("\n        无需下载APP，微信扫码即用\n      ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "qr-card" }, [
      _c("img", {
        attrs: {
          src: require("../../static/images/wechat/applet-qr-code.jpg"),
          alt: "小程序码"
        }
      }),
      _vm._v(" "),
      _c("p", { staticClass: "qr-cap" }, [_vm._v("微信扫一扫 · 进入小程序")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h3", [_vm._v("实时到站查询")]),
      _vm._v(" "),
      _c("p", [
        _vm._v("车辆位置实时可见，还有几站、多久到站一目了然，出行不再干等。")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h3", [_vm._v("换乘路线规划")]),
      _vm._v(" "),
      _c("p", [
        _vm._v("输入起点终点，一键规划公交换乘方案，步行、候车时间全知道。")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h3", [_vm._v("通勤常用收藏")]),
      _vm._v(" "),
      _c("p", [
        _vm._v("常用线路与站点收藏在首页，通勤卡片一屏即见，查车更快。")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h3", [_vm._v("站点周边线路")]),
      _vm._v(" "),
      _c("p", [
        _vm._v("定位或搜索任意站点，周边经过线路全部掌握，换乘不迷路。")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "sec sec-alt" }, [
      _c("h2", [_vm._v("三种方式进入小程序")]),
      _vm._v(" "),
      _c("p", { staticClass: "sec-sub" }, [
        _vm._v("无需下载 · 即扫即用 · 免费便民")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "way-list" }, [
        _c("div", { staticClass: "way" }, [
          _c("span", { staticClass: "num" }, [_vm._v("1")]),
          _vm._v(" "),
          _c("h3", [_vm._v("站台扫码")]),
          _vm._v(" "),
          _c("p", [_vm._v("用微信「扫一扫」扫描公交站台上的二维码")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "way" }, [
          _c("span", { staticClass: "num" }, [_vm._v("2")]),
          _vm._v(" "),
          _c("h3", [_vm._v("微信搜索")]),
          _vm._v(" "),
          _c("p", [_vm._v("微信内搜索小程序「果城行丨公共出行服务查询」")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "way" }, [
          _c("span", { staticClass: "num" }, [_vm._v("3")]),
          _vm._v(" "),
          _c("h3", [_vm._v("本页扫码")]),
          _vm._v(" "),
          _c("p", [_vm._v("微信扫一扫上方小程序码，或截图后长按识别")])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "sec" }, [
      _c("h2", [_vm._v("关于我们")]),
      _vm._v(" "),
      _c("p", { staticClass: "sec-sub" }, [_vm._v("立足南充 · 服务本地出行")]),
      _vm._v(" "),
      _c("div", { staticClass: "about-card" }, [
        _c("p", { staticClass: "about-text" }, [
          _vm._v(
            "\n          南充七安网络科技有限公司立足南充，专注本地智慧出行服务，\n          自主研发运营「果城行丨公共出行服务查询」微信小程序，\n          为市民提供公交实时到站查询、换乘规划、站点查询等便民服务。\n        "
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("footer", { staticClass: "foot" }, [
      _c("p", { staticClass: "foot-copy" }, [
        _vm._v("Copyright © 2019-2026 南充七安网络科技有限公司")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "foot-beian" }, [
        _c(
          "a",
          {
            attrs: {
              href: "https://beian.miit.gov.cn/",
              target: "_blank",
              rel: "noopener nofollow"
            }
          },
          [_vm._v("蜀ICP备2024078067号-12")]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-29fa7a92", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29fa7a92","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/HelloWorld.vue
// module id = null
// module chunks = 